module.exports = __webpack_public_path__ + "static/media/Warning.bc865b05.svg";